/**
 * MUI OutlinedInput renders at this height by default (10px vertical padding +
 * 16px line-height + 1.25px border rounding). Use this when sizing adjacent
 * non-input elements (e.g. icon buttons) to align with standard text inputs.
 */
export const MUI_INPUT_HEIGHT_PX = 37.25;
